export default "__VITE_ASSET__CKtJg9UW__"